import React, { useMemo, useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Button,
} from '@lockerpm/design';

import {
  UndoOutlined,
} from "@ant-design/icons";

import securityDrawersComponents from "./drawers";
import { KdfType } from "../../../../secrets-web/src/core-js/src/enums/kdfType";
import { separatorNumber } from "../../../../secrets-web/src/utils/common";

const EncryptionKeySettings = (props) => {
  const { UpdateEncryptionSettingsDrawer } = securityDrawersComponents;
  const {
    className = '',
  } = props;
  const { t } = useTranslation();

  const isMobile = useSelector(state => state.system.isMobile);
  const userInfo = useSelector(state => state.auth.userInfo);

  const [formVisible, setFormVisible] = useState(false);

  const disabled = useMemo(() => {
    return true
    // return userInfo?.kdf_version < 1
  }, [userInfo])

  return (
    <div className={className}>
      <div className="flex justify-between">
        <p className="font-semibold text-xl text-primary">
          {t('update_encryption.title')}
        </p>
        <Button
          type='primary'
          ghost
          icon={<UndoOutlined />}
          disabled={disabled}
          onClick={() => setFormVisible(true)}
        >
          {isMobile ? '' : t('update_encryption.action')}
        </Button>
      </div>
      <p className="mt-1">
        {t('update_encryption.description')}
      </p>
      <div className="mt-4 flex flex-col gap-1">
        <p>
          <span className="font-semibold">{t('update_encryption.algorithm')}</span>: {userInfo?.kdf === KdfType.PBKDF2_SHA256 ? 'PBKDF2' : 'ARGON2ID'}
        </p>
        <p><span className="font-semibold">{t('update_encryption.iterations')}</span>: { separatorNumber(userInfo.kdf_iterations) }</p>
        {
          userInfo?.kdf === KdfType.ARGON2ID && <>
            <p><span className="font-semibold">{t('update_encryption.memory')}</span>: { separatorNumber((userInfo?.kdf_memory || 0) / 1024) }</p>
            <p><span className="font-semibold">{t('update_encryption.parallelism')}</span>: { separatorNumber(userInfo.kdf_parallelism || 0) }</p>
          </>
        }
      </div>
      {/* <UpdateEncryptionSettingsDrawer
        visible={formVisible}
        onClose={() => setFormVisible(false)}
      /> */}
    </div>
  );
}

export default EncryptionKeySettings;
